<template>
  <div class="form-calc">
    <p class="alert">Caso não esteja vendo o formulario, por favor desabilite o adblocker</p>
    <img class="logobody" src="../../public/novologolaranja.svg" />
    <div role="main" id="calculadora-nova-5d3cd633c6102a8d675e"></div>
  </div>
</template>

<script>
export default {
  name: "FormCalc",
  data() {
    return {
      cep: "",
      adress: {}
    };
  },
  mounted() {
    new RDStationForms(
      "calculadora-nova-5d3cd633c6102a8d675e",
      "UA-98002719-1"
    ).createForm();
    console.log("aa");
    window.fbq('track', 'CompleteRegistration');
    window.gtag('event', 'conversion', {'send_to': 'AW-826902790/eg16CLXqh_gBEIaSpooD'});
  },
  watch: {
    cep(value) {
      if (value.length === 8) {
        fetch(`https://viacep.com.br/ws/${value}/json`)
          .then(r => r.json())
          .then(r => {
            this.adress = r;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/style.scss";

* {
  outline: 0;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

button {
  text-align: center;
}

form div {
  display: flex;
}

.alert {
  position: absolute;
  top: 2em;
  left: 20em;
  color: #ff8412;
  text-align: center;
  font-weight: bold;
  font-size: 12px;
}

.form-calc {
  top: 50%;
  left: 50%;
  margin-right: -50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 118px 130px 90px 130px;
  width: 858px;
  height: 37em;
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #4605894d;
  border-radius: 48px;
  position: absolute;
  z-index: 2;
}

select {
  color: $purple;
  font-weight: bold;
  font-size: 18px;
  display: block;
  margin-bottom: 2em;
}

button {
  width: 100%;
  height: 62px;
  background: $purple 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #4605894d;
  border-radius: 20px;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

label {
  text-align: left;
  font-size: 12px;
  letter-spacing: 0;
  color: $light-orange;
  text-transform: uppercase;
  display: block;
  margin-bottom: 1em;
}

input {
  color: $purple;
  font-weight: bold;
  font-size: 18px;
  display: block;
  margin-bottom: 2em;
}

.fixsize {
  width: 100%;
}

.btn {
  height: 62px;
  box-shadow: 0px 20px 20px #4605894d;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  display: block;
  line-height: 4em;
}

.btn-hire {
  background: $purple 0% 0% no-repeat padding-box;
  margin-bottom: 40px;
}

.captcha {
  font-size: 18px;
}

::placeholder {
  color: $purple;
}

.logobody {
  position: absolute;
  right: 2em;
  top: 2em;
  width: 120px;
  height: 45px;
}

@media only screen and (max-width: 600px) {
  .form-grid {
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 27em;
  }

  .alert {
    display: none;
  }

  .form-calc {
    padding: 46px 25px;
    height: 100%;
    width: 19.5em;
    top: 50% !important;
    left: 50% !important;
    margin-right: -50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .logobody {
    display: none;
  }

  form div {
    flex-direction: column;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .form-calc {
    top: 50%;
    left: 50%;
    margin-right: -50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 95%;
    height: 85%;
  }
}
</style>
